import {
  doc,
  setDoc,
  collection,
  query,
  where,
  getDocs
} from "firebase/firestore";
import { db } from "../firebase";
import Cookies from "js-cookie";
import { Randomcode } from "../components_root/rendom_code";

export const Save_phonebook = async (data) => {
  const { category, mobilenumber } = data || {};

  // 1. Validate inputs
  if (!category?.trim()) {
    return { success: false, error: "Missing category." };
  }
  if (!mobilenumber?.trim()) {
    return { success: false, error: "Missing mobile number." };
  }

  const sessiontoken = Cookies.get("sessiontoken");
  const guid = Cookies.get("guid");

  if (!sessiontoken || sessiontoken === "undefined") {
    return { success: false, error: "Session expired. Please relogin." };
  }

  if (!guid || guid === "undefined") {
    return { success: false, error: "Login expired. Please relogin." };
  }

  try {
    const tablename = "phonebook";

    // ✅ Check if mobilenumber already exists for this user
    const phonebookQuery = query(
      collection(db, tablename),
      where("guid", "==", guid)
    );
    const snapshot = await getDocs(phonebookQuery);

    for (const docSnap of snapshot.docs) {
      const fieldsSnap = await getDocs(collection(docSnap.ref, "fields"));
      for (const fieldDoc of fieldsSnap.docs) {
        const { fieldName, fieldValue } = fieldDoc.data();
        if (fieldName === "mobilenumber" && fieldValue === mobilenumber) {
          return { success: false, error: "Mobile number already exists." };
        }
      }
    }

    // ✅ Save parent document
    const uid = Randomcode(15);
    const parentDocRef = doc(db, tablename, uid);
    const savequery = {
      uid,
      category,
      status: true,
      guid,
      sessiontoken,
      date_time: new Date(),
        date_time_update: new Date(),
    };
    await setDoc(parentDocRef, savequery);

    // ✅ Save fields in subcollection "fields"
    const fieldsCollection = collection(parentDocRef, "fields");
    for (const [fieldName, fieldValue] of Object.entries(data)) {
      if (fieldValue === null || fieldValue === undefined || fieldValue === "") {
        continue;
      }
   if (fieldName === "category") {
        continue;
      }
      const docid = Randomcode(22);
      const savedata = {
        docid,
        uid,
        guid,
        sessiontoken,
        fieldName,
        fieldValue,
      };

      const fieldDocRef = doc(fieldsCollection, docid);
      await setDoc(fieldDocRef, savedata);
    }

    return { success: true };

  } catch (err) {
    console.error("❌ Error saving document:", err);
    return { success: false, error: err.message || "Unknown error" };
  }
};
